import { Airplane } from './airplane';

export const AIRPLANES: Airplane[] = [
  { caption: 'A fast airplane', url: 'https://photos.smugmug.com/Galleries/Transport/Flying-Machines/i-ntFS6zz/3/d6b98d58/L/20121005-7754-Edit-L.jpg' },
  { caption: 'A slow airplane', url: 'https://photos.smugmug.com/Galleries/Transport/Flying-Machines/i-k5v7246/3/78fed83b/L/20120704-3639_40_41-Edit-Edit-Edit-L.jpg' },
  { caption: 'A Blue Angel', url: 'https://photos.smugmug.com/Galleries/Transport/Flying-Machines/i-rVF7nhC/3/5039411d/L/20121005-7864-Edit-L.jpg' }
  ];